// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__qGmhg","file":"styles_file__27fvb"};